/**
 * Currency API Service
 * Service layer for currency-related API calls
 *
 * CU-1a masters flip: `list` gains the live-module leg (the `masters` key,
 * client.ts) riding the CurrencyOptions contract operation against the
 * B2.2' `currencies` reference root — the D-REF-2 BE half is live.
 *
 * F2.2 REMOVED in the same slice: the 404/501→empty-list degrade existed
 * because the gold REST seam had no /currencies route; gold loses masters
 * duty at CU-1, and BOTH remaining seams (MSW mock + live graph) serve
 * currencies, so a missing route is a real defect again and must throw.
 * `currencyNoFallback` (currencyApi vitest) is the no-fallback pin.
 */

import apiClient from './axios.config';
import { isLiveModule } from './client';
import { gqlRequest } from './graphql.client';
import { mastersOperations, type CurrencyOptionsResult } from './masters.operations';
import { mapCurrencyNode } from './masters.gql-map';
import type { CurrenciesResponse } from '@/types/api/currency';

/**
 * Currency API service object
 */
export const currencyApi = {
  /**
   * GET /api/currencies
   * Get list of available platform currencies
   */
  list: async (): Promise<CurrenciesResponse> => {
    if (isLiveModule('masters')) {
      const result = await gqlRequest<CurrencyOptionsResult>(
        mastersOperations.currencyOptions,
        {}
      );
      return { data: result.currencies.map(mapCurrencyNode) };
    }
    const response = await apiClient.get<CurrenciesResponse>('/currencies');
    return response.data;
  },
};

export default currencyApi;
